/**
 * THE BOTTOM BAR AND THE PHONE'S KEYBOARD (Jamie 24/10/26: the console's bar "scrolling up" the page on an iPhone).
 *
 * On iOS, while the keyboard is up, a bar fixed to the bottom of the screen is placed against the shrunken view, and
 * after the keyboard goes it can stay stuck half-way up the page until something makes Safari lay the page out again.
 * So on touch screens: the bar is hidden while a text box has the keyboard (`html.kb-open`; it isn't needed while
 * typing and it covers the field), and when the keyboard goes the page is nudged by a pixel and back, which puts every
 * fixed bar back where it belongs. The company app and the console both use it (main.tsx).
 */
const FIELD = 'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="range"]):not([type="file"]):not([type="color"]), textarea, select, [contenteditable="true"]';
const isField = (el) => el instanceof HTMLElement && el.matches(FIELD);
export function watchKeyboard() {
    if (typeof window === "undefined" || !(navigator.maxTouchPoints > 0 || window.matchMedia?.("(pointer: coarse)").matches))
        return;
    const root = document.documentElement;
    let timer;
    const settle = () => { window.scrollBy(0, 1); window.scrollBy(0, -1); };
    document.addEventListener("focusin", (e) => { if (isField(e.target)) {
        window.clearTimeout(timer);
        root.classList.add("kb-open");
    } });
    document.addEventListener("focusout", () => {
        window.clearTimeout(timer);
        // Moving from one box to the next keeps the keyboard up: only act once nothing has the keyboard.
        timer = window.setTimeout(() => {
            if (isField(document.activeElement))
                return;
            root.classList.remove("kb-open");
            settle();
            window.setTimeout(settle, 300);
        }, 100);
    });
    // The keyboard closed some other way (the "Done" key, a swipe): the view is back to full height.
    const vv = window.visualViewport;
    vv?.addEventListener("resize", () => { if (vv.height > window.innerHeight * 0.85 && !isField(document.activeElement)) {
        root.classList.remove("kb-open");
        settle();
    } });
}
